import { render, staticRenderFns } from "./DataPetugas.vue?vue&type=template&id=00ac1f14&"
import script from "./DataPetugas.vue?vue&type=script&lang=js&"
export * from "./DataPetugas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports